export const ERRORS = {
  commonError: 'Oops, something went wrong',
  tryUpdatePage: 'An\u00A0error has occurred. Try refreshing the\u00A0page',
  fieldIsRequired: 'This field is required',

  firstNameIsRequired: 'Enter first name',
  minFirstName: 'First name must contain at least 2 characters',
  maxFirstName: 'First name must not exceed 32 characters',
  firstNameNotAllowedSpaces: 'First name must not begin or end with a space',
  firstNameAllowedСharacters: 'First name must contain only letters and spaces',
  firstNameOnlySpaces: 'First name must not contain only spaces',

  lastNameIsRequired: 'Enter last name',
  minLastName: 'Last name must contain at least 2 characters',
  maxLastName: 'Last name must not exceed 32 characters',
  lastNameNotAllowedSpaces: 'Last name must not begin or end with a space',
  lastNameAllowedСharacters: 'Last name must contain only letters and spaces',
  lastNameOnlySpaces: 'Last name must not contain only spaces',

  emailIsRequired: 'Enter email',
  invalidEmail: 'Invalid email address',
  emailExist: 'Account is already registered',

  minPassword: 'Password must contain at least 6 characters',
  maxPassword: 'Password must not exceed 40 characters',
  passwordsDoNotMatch: 'Passwords do not match',

  incorrectEmailOrPassword: 'Incorrect email or password',

  dateIsRequired: 'Enter date',
  passedDate: 'The selected date has already passed',

  timeIsRequired: 'Enter time',
  passedTime: 'The selected time has already passed',

  minTopic: 'Enter your debate topic',
  maxTopic: 'The "Debate topic" field must not exceed 150 characters',
  topicOnlySpaces: 'The "Debate topic" field must not contain only spaces',

  minDescription: 'Enter your debate description',
  maxDescription: 'The "Debate description" field must not exceed 1000 characters',
  descriptionOnlySpaces: 'The "Debate description" field must not contain only spaces',

  minPersonalInfo: 'The "About" field must contain at least 2 characters',
  maxPersonalInfo: 'The "About" field must not exceed 40 characters',
  personalInfoOnlySpaces: 'The "About" field must not contain only spaces',

  captchaRequired: 'Please complete the reCAPTCHA check',
  privacyPolicyRequired: 'You must agree to the Privacy Policy',
} as const;

export const RESPONSE_CODES = {
  notAthenticated: 'not_authenticated',
  notFound: 'not_found',
  invalid: 'invalid',
  unique: 'unique',
  validationError: 'validation_error',
  permissionDenied: 'permission_denied',
} as const;

export const RESPONSE_ATTRIBUTES = {
  startDatetime: 'start_datetime',
} as const;
